import React from 'react';
import {Link} from 'react-router-dom';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";

import createLink from "../../libs/createLink";

import {fetchUserFollowers, resetUserFollowers} from "../../creators/user.followers";

import Icon from './Icon';
import Avatar from './Avatar';
import {isNoFollowProfil} from "../../libs/helper";

class FollowersList extends React.Component {
    constructor(props){
        super(props);
        this.props.fetchUserFollowers(this.props.User._id, {limit : false});
    };


    render(){
        return (
            <div id="userStatList">
                <div className="container">
                    <div className="card">
                        <div className="topline">
                            <span>{this.props.userFollowers && (this.props.userFollowersTotal || 0)} {this.props.userFollowersTotal === 1 ? "personne suit" : "personnes suivent"}&nbsp;
                                <span className="userStatList-username">{this.props.User && this.props.User.username}</span>
                            </span>
                            <span onClick={() => this.props.handleClose()}><Icon type="close"/></span>
                        </div>
                        <div className="user-stat-list">
                            <ul className="user-stat-list-container">
                                {this.props.userFollowers && this.props.userFollowers.map((user, index) => {
                                    let relLinkProfil = isNoFollowProfil(user) ? { rel: "nofollow" } : {};
                                    return (
                                    <li key={index}>
                                        <Link to={createLink('userProfile', user)}
                                              {...relLinkProfil}
                                              onClick={() => this.props.handleClose()}>
                                            <Avatar avatar={user.profile.avatar} gender={user.profile.gender}
                                                    className="user-thumb" alt=""/>
                                            {user.username}
                                        </Link>
                                    </li>
                                )})}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return {
        userFollowers: state.userFollowers.data,
        userFollowersLoading: state.userFollowers.loading,
        userFollowersInitialized: state.userFollowers.initialized,
        userFollowersTotal: state.userFollowers.total
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserFollowers,
    resetUserFollowers
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FollowersList);